import React from "react";
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material/styles";

const ThemeProviderCtx = React.createContext();
ThemeProviderCtx.displayName = "ThemeProviderCtx";

// To Be Optimized
const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = React.useState("dark");
  const muiTheme = createTheme({
    palette: {
      mode: theme,
    },
    typography: {
      fontFamily: ["Inter", "Helvetica", "Arial", "sans-serif"].join(","),
      fontWeightLight: 200,
      fontWeightRegular: 300,
      fontWeightMedium: 400,
      fontWeightBold: 500,
    },
  });

  return (
    <ThemeProviderCtx.Provider value={[theme, setTheme]}>
      <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
    </ThemeProviderCtx.Provider>
  );
};

const useTheme = () => React.useContext(ThemeProviderCtx);

export { ThemeProvider, useTheme };
